import {
  Space,
  Table,
  Button,
  notification,
  Modal,
  Row,
  Typography,
  Image,
  Input,
  DatePicker,
} from "antd";
import type { ColumnsType } from "antd/lib/table";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import styles from "./redaction.module.css";
import { FC, useEffect, useState } from "react";
import { useEssays } from "../../hooks/useEssays";
import { GetRedactions_getRedactions } from "../../__generated__/gql-types/GetRedactions";

const { Text } = Typography;
const { Search } = Input;

const Redactions: FC = () => {
  const { deleteEssay, loading: isLoading, essays } = useEssays();
  const [dataSource, setdataSource] = useState<
    GetRedactions_getRedactions[] | null
  >([]);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [idEssay, setIdEssay] = useState<string>("");

  useEffect(() => {
    setdataSource(essays);
  }, [essays]);

  const showModal = (id: string) => {
    setIsModalVisible(true);
    setIdEssay(id);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = async () => {
    try {
      await deleteEssay(idEssay);
      setIsModalVisible(false);
    } catch {
      notification["error"]({
        message: "Eliminación Erronea",
        description: "El ensayo no pudo ser eliminado!",
        placement: "top",
        duration: 3,
      });
    }
  };

  const columns: ColumnsType<GetRedactions_getRedactions> = [
    {
      align: "center",
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    { align: "center", title: "Título", dataIndex: "title", key: "title" },
    {
      align: "center",
      title: "Acciones",
      key: "acciones",
      render: (_, record) => {
        return (
          <Space size={15} style={{ fontSize: 19 }}>
            <Link to={`/essays/${record.id}`} state={record.id}>
              <Button icon={<SearchOutlined />}>Editar</Button>
            </Link>
            <Button
              onClick={() => {
                showModal(record.id);
              }}
              danger
            >
              Eliminar
            </Button>
          </Space>
        );
      },
    },
  ];

  const onSearch = (value: string) => {
    if (value === "") {
      setdataSource(essays);
    } else {
      if (dataSource) {
        const filteredData: GetRedactions_getRedactions[] = dataSource.filter(
          (data) => data.title?.includes(value)
        );
        setdataSource(filteredData);
      }
    }
  };

  const onSearchId = (value: string) => {
    if (value === "") {
      setdataSource(essays);
    } else {
      if (dataSource) {
        const filteredData: GetRedactions_getRedactions[] = dataSource.filter(
          (data) => data.id === value
        );
        setdataSource(filteredData);
      }
    }
  };

  return (
    <div className={styles.container}>
      <h1>Ensayos</h1>
      <div className={styles.newQuizzesContainer}>
        <Space direction="vertical" style={{ marginRight: 20 }}>
          <Search
            placeholder="Buscar por id"
            onSearch={onSearchId}
            enterButton
          />
        </Space>
        <Space direction="vertical" style={{ marginRight: 20 }}>
          <Search
            placeholder="Buscar por título"
            onSearch={onSearch}
            enterButton
          />
        </Space>
        <Button type="primary" danger>
          <Link to="/essays/new">Nuevo Ensayo</Link>
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={dataSource ?? []}
        loading={isLoading}
        rowKey={(record) => record.id}
      />
      <Modal
        title="Eliminar Ensayo"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>¿Desea eliminar el ensayo?</p>
      </Modal>
    </div>
  );
};

export default Redactions;
